<template>
  <div :class="$b()">
    <h1 :class="$b('title', { 'without-subtitle': !hasSubtitle })">
      {{ title }}
    </h1>

    <h2 v-if="hasSubtitle" :class="$b('subtitle')">
      {{ subtitle }}
    </h2>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';

@Component({
  name: 'WelcomeHeading',
})
export default class WelcomeHeading extends Vue {
  @Prop({ type: String, required: true })
  readonly title: string;

  @Prop({ type: String, default: '' })
  readonly subtitle: string;

  get hasSubtitle(): boolean {
    return !!this.subtitle;
  }
}
</script>

<style lang="scss" scoped>
@use 'src/assets/scss/variables' as v;

.dp-welcome-heading {
  padding-bottom: 2.66rem;

  &__title,
  &__subtitle {
    font-size: v.$h2-font-size;
    letter-spacing: v.$letter-spacing-tight;
    line-height: 1.3;
  }

  &__title {
    font-weight: v.$font-weight-semibold;

    &--without-subtitle {
      display: block;
      font-size: v.$font-size-lg;
      line-height: v.$line-height-normal;

      @screen sm {
        font-size: v.$h2-font-size;
        line-height: v.$line-height-normal;
      }
    }
  }

  &__subtitle {
    color: v.$gray-600;
    font-weight: v.$font-weight-medium;
  }
}
</style>
